import useAuthStore from '@/stores/authStore';
import type { NavigationGuardWithThis } from 'vue-router';

export default <NavigationGuardWithThis<undefined>>((to, _from, next) => {
  const authStore = useAuthStore();
  if (!authStore.isReported && to.name !== 'company.pscl') {
    return next({
      name: 'company.pscl',
    });
  }

  return next();
});
